import Vue from 'vue'
import Vuex from 'vuex'
import axios from './axios'

Vue.use(Vuex)

const bloodBagStatus = {
  // Unknown: 0,
  // Expired: 1,
  // GiveAway: 2
  AVAILABLE: 0,
  RESERVE: 1,
  DISBURSE: 2,
  EXPIRE: 3,
  USED: 4,
  TRANSFER: 5
}

export default new Vuex.Store({
  initalizerAction: 'getBloodCollectionData',
  state: {
    bloodCollection: []
  },
  mutations: {
    updateBloodCollection (state, bloodCollection) {
      state.bloodCollection = bloodCollection
    }
  },
  actions: {
    getBloodCollectionData (context) {
      return new Promise((resolve, reject) => {
        axios.get('bloodbank/hospitalbloodcollection/').then((response) => {
          context.commit('updateBloodCollection', response.data.result)
          resolve()
        })
      })
    }
  },
  getters: {
    getValidBloodCollection: (state, getters) => {
      return state.bloodCollection.filter(bag => {
        // return bag.bag_status !== bloodBagStatus.Expired &&
        //        bag.collected_quantity > 0 &&
        //        bag.remove_reason == null
        return bag.bag_status !== bloodBagStatus.DISBURSE &&
                bag.collected_quantity > 0 &&
                bag.remove_reason == null &&
                bag.status !== bloodBagStatus.USED
      })
    }
  }
})
